/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListGatewaySessionFacetsSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type ListGatewaySessionFacetsRequest = {
  /**
   * Project gateway id. Omit for the Organization Gateway; organization access is then required and the selected project is ignored.
   */
  gatewayId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type ListGatewaySessionFacetsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const ListGatewaySessionFacetsSecurity$outboundSchema: z.ZodMiniType<
  ListGatewaySessionFacetsSecurity$Outbound,
  ListGatewaySessionFacetsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function listGatewaySessionFacetsSecurityToJSON(
  listGatewaySessionFacetsSecurity: ListGatewaySessionFacetsSecurity,
): string {
  return JSON.stringify(
    ListGatewaySessionFacetsSecurity$outboundSchema.parse(
      listGatewaySessionFacetsSecurity,
    ),
  );
}

/** @internal */
export type ListGatewaySessionFacetsRequest$Outbound = {
  gateway_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const ListGatewaySessionFacetsRequest$outboundSchema: z.ZodMiniType<
  ListGatewaySessionFacetsRequest$Outbound,
  ListGatewaySessionFacetsRequest
> = z.pipe(
  z.object({
    gatewayId: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gatewayId: "gateway_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function listGatewaySessionFacetsRequestToJSON(
  listGatewaySessionFacetsRequest: ListGatewaySessionFacetsRequest,
): string {
  return JSON.stringify(
    ListGatewaySessionFacetsRequest$outboundSchema.parse(
      listGatewaySessionFacetsRequest,
    ),
  );
}
